import React from 'react';
import { Modal } from 'is24-corecss';
import { Benefit } from '../../../../../@types/benefits';
import KlarWattPng from './images/KlarWatt-Horizontal.png';
import KlarWattWebp from './images/KlarWatt-Horizontal.webp';
import KlarWattMobilePng from './images/KlarWatt-Horizontal-mobile.png';
import KlarWattMobileWebp from './images/KlarWatt-Horizontal-mobile.webp';
import type { BenefitModalProps } from '../../../../../@types/benefitModalProps';
import { ProductType } from '../../../../../@types/product';
import { useGetHasProduct, useHasWohnenPlusLight } from '@/customHooks/useGetHasProduct.hook';
import ModalV2 from '@/components/common/display/modal/ModalV2';
import { default as Msg } from '@/i18n/components/FormattedMessage';
import { useIntl } from '@/i18n/hooks/useIntl';
import { campaigns } from '@/components/common/campaigns';

const styles = {
  overviewTab: { maxWidth: 530 },
};

export const OverviewTab = () => {
  return (
    <div style={styles.overviewTab}>
      <div className='font-heading-xsmall-regular padding-bottom-l'>
        <Msg
          id='benefits.greenElectricity.modal.overview.paragraph1'
          defaultMessage='Dein exklusiver Wohnen+ auf deinen Stromtarif mit KlarWatt'
        />
      </div>
      <div className='padding-bottom-l'>
        <Msg
          id='benefits.greenElectricity.modal.overview.paragraph2'
          defaultMessage='Als Wohnen+ Mitglied profitierst du von einem exklusiven Rabatt auf KlarWatt, den dynamischen Ökostromtarif von ImmoScout24. Spare bis zu 40% durch tagesgenaue Börsenpreise – mit Preisbremse bei 37,89 Cent/kWh und monatlicher Kündigungsfrist.'
        />
      </div>
    </div>
  );
};

export const GreenElectricity = ({ isVisible, onClose }: BenefitModalProps) => {
  const { t } = useIntl();
  const hasWohnenPlus = useGetHasProduct(ProductType.WohnenPlus);
  const hasWohnenPlusLight = useHasWohnenPlusLight();
  const isEntitled = hasWohnenPlus || hasWohnenPlusLight;
  const link = isEntitled ? campaigns.KLARWATT_LANDING_PAGE : campaigns.KLARWATT_DISCOVER_WOHNEN_PLUS;

  return (
    <ModalV2
      title={t({
        id: 'benefits.greenElectricity.modal.headline',
        defaultMessage: 'KlarWatt Ökostrom',
      })}
      isVisible={isVisible}
      image={KlarWattPng}
      imageWebp={KlarWattWebp}
      imageMobile={KlarWattMobilePng}
      imageMobileWebp={KlarWattMobileWebp}
      imageAlt={t({
        id: 'benefits.greenElectricity.modal.image',
        defaultMessage: 'KlarWatt Ökostrom',
      })}
      imageUseFullWidth={true}
      tabsContent={[<OverviewTab key='benefits.greenElectricity.modal.overview' />]}
      benefit={Benefit.GREEN_ELECTRICITY}
      onClose={onClose}
      primaryFooterBtn={
        <Modal.PrimaryFooterButton
          label={
            isEntitled
              ? t({
                  id: 'benefits.greenElectricity.modal.overview.ctaText',
                  defaultMessage: 'Jetzt Tarif mit Rabatt berechnen',
                })
              : t({
                  id: 'benefits.greenElectricity.modal.overview.discoverWohnenPlus',
                  defaultMessage: 'Wohnen+ entdecken',
                })
          }
          onClick={() => {
            window.location.href = link;
          }}
        />
      }
    />
  );
};

export default GreenElectricity;
